import comp from "./ColumnInfoTooltip";
export default comp;
